/**
 * Joins class names, dropping anything falsy.
 *
 * Deliberately not `clsx`: the whole requirement is one line, and a dependency
 * added to a bundle that ships financial dashboards should earn its place.
 */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ')
}
